export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  setDetail(state, data) {
    state.detail = data;
  },

  setPage(state, page = 1) {
    state.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },
  /* -------------------------------------------------------------- */

  setAdminNoticeList(state, list) {
    state.adminNotice.list = [...state.adminNotice.list, ...list];
  },

  setMainNoticeList(state, list) {
    state.notice.list = list;
  },

  initNoticeList(state) {
    state.notice.list = [];
    state.notice.page = 1;
    state.notice.totalPage = 2;
  },

  setNoticeList(state, responseList) {
    state.notice.list = [...state.notice.list, ...responseList];
  },

  setNoticePage(state, page = 1) {
    state.notice.page = page;
  },

  setNoticeTotalPage(state, totalPage = 2) {
    state.notice.totalPage = totalPage;
  },

  setNotice(state, data) {
    state.notice.content = data;
  },

  setAdminNotice(state, data) {
    state.adminNotice.content = data;
  },

  /* --------------------------------- Event --------------------------------- */
  setMainEventList(state, list) {
    state.event.list = list;
  },

  initEventList(state) {
    state.event.list = [];
    state.event.page = 1;
    state.event.totalPage = 2;
  },

  setEventList(state, responseList) {
    state.event.list = [...state.event.list, ...responseList];
  },

  setEventPage(state, page = 1) {
    state.event.page = page;
  },

  setEventTotalPage(state, totalPage = 2) {
    state.event.totalPage = totalPage;
  },

  setEvent(state, payload) {
    state.event.content = payload;
  }
};
